// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.searchFiltersWorkspace_JpFyL {
  display: flex;
  align-items: center;
  gap: 10px;
  .searchIconsWrappers_lpQaq,.filterIconsWrappers_Xblm2 {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
    background: var(--ececf1-background);
    cursor: pointer;
    -webkit-user-select: none;
            user-select: none;
    border-radius: 6px;
  }
  .filterIconsWrappers_Xblm2{
    height: 32px;
    width: 32px;
  }

  
}

.labelContainer_ev2Xg{
  display: flex;
  flex-direction: column;

  .label_tVNkc{
      display: flex;
      flex-direction: column;
      border-bottom: 1px solid #ebebeb;
      padding: 10px 0;
      gap: 10px;
      .infoWorkspace_mW6vr{
          display: flex;
          align-items: center;
          justify-content: space-between;
          width: 100%;
          >div{
              display: flex;
              align-items: center;
              gap: 5px;
              .info_yHzi8{
                display: flex;
                flex-direction: column;
                p{
                    margin: 0;
                }
                span{
                    color: #717171;
                    font-size: 13px;
                }
              }
          }
          svg{
            height: 36px;
            width: 36px;
          }
      }

      .infoUser_w7d6p{
        display: flex;
        align-items: center;
        gap: 10px;
        margin-left: 10px;
        .initials_AARIp{
            width: 34px;
            height: 34px;
            min-width: 34px;
            border-radius: 9999px;
            display: flex;
            align-items: center;
            justify-content: center;
            background: var(--_16c098-background);
            color: var(--white-color);
            font-size: 16px;
            font-weight: 600;
            text-transform: uppercase;
        }
        .info_yHzi8{
            display: flex;
            flex-direction: column;
            p{
                margin: 0;
                display: flex;
                align-items: center;
                gap: 5px;
                color: #666666;
            }
            span{
                color: #717171;
                font-size: 13px;
            }
        }
      }
  }
}`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/GeneralSettings/components/Workspace/Workspace.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,YAAY;IACZ,WAAW;EACb;;;AAGF;;AAEA;EACE,aAAa;EACb,sBAAsB;;EAEtB;MACI,aAAa;MACb,sBAAsB;MACtB,gCAAgC;MAChC,eAAe;MACf,SAAS;MACT;UACI,aAAa;UACb,mBAAmB;UACnB,8BAA8B;UAC9B,WAAW;UACX;cACI,aAAa;cACb,mBAAmB;cACnB,QAAQ;cACR;gBACE,aAAa;gBACb,sBAAsB;gBACtB;oBACI,SAAS;gBACb;gBACA;oBACI,cAAc;oBACd,eAAe;gBACnB;cACF;UACJ;UACA;YACE,YAAY;YACZ,WAAW;UACb;MACJ;;MAEA;QACE,aAAa;QACb,mBAAmB;QACnB,SAAS;QACT,iBAAiB;QACjB;YACI,WAAW;YACX,YAAY;YACZ,eAAe;YACf,qBAAqB;YACrB,aAAa;YACb,mBAAmB;YACnB,uBAAuB;YACvB,qCAAqC;YACrC,yBAAyB;YACzB,eAAe;YACf,gBAAgB;YAChB,yBAAyB;QAC7B;QACA;YACI,aAAa;YACb,sBAAsB;YACtB;gBACI,SAAS;gBACT,aAAa;gBACb,mBAAmB;gBACnB,QAAQ;gBACR,cAAc;YAClB;YACA;gBACI,cAAc;gBACd,eAAe;YACnB;QACJ;MACF;EACJ;AACF","sourcesContent":[".searchFiltersWorkspace {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  .searchIconsWrappers,.filterIconsWrappers {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 18px;\n    height: 18px;\n    background: var(--ececf1-background);\n    cursor: pointer;\n    user-select: none;\n    border-radius: 6px;\n  }\n  .filterIconsWrappers{\n    height: 32px;\n    width: 32px;\n  }\n\n  \n}\n\n.labelContainer{\n  display: flex;\n  flex-direction: column;\n\n  .label{\n      display: flex;\n      flex-direction: column;\n      border-bottom: 1px solid #ebebeb;\n      padding: 10px 0;\n      gap: 10px;\n      .infoWorkspace{\n          display: flex;\n          align-items: center;\n          justify-content: space-between;\n          width: 100%;\n          >div{\n              display: flex;\n              align-items: center;\n              gap: 5px;\n              .info{\n                display: flex;\n                flex-direction: column;\n                p{\n                    margin: 0;\n                }\n                span{\n                    color: #717171;\n                    font-size: 13px;\n                }\n              }\n          }\n          svg{\n            height: 36px;\n            width: 36px;\n          }\n      }\n\n      .infoUser{\n        display: flex;\n        align-items: center;\n        gap: 10px;\n        margin-left: 10px;\n        .initials{\n            width: 34px;\n            height: 34px;\n            min-width: 34px;\n            border-radius: 9999px;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            background: var(--_16c098-background);\n            color: var(--white-color);\n            font-size: 16px;\n            font-weight: 600;\n            text-transform: uppercase;\n        }\n        .info{\n            display: flex;\n            flex-direction: column;\n            p{\n                margin: 0;\n                display: flex;\n                align-items: center;\n                gap: 5px;\n                color: #666666;\n            }\n            span{\n                color: #717171;\n                font-size: 13px;\n            }\n        }\n      }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"searchFiltersWorkspace": `searchFiltersWorkspace_JpFyL`,
	"searchIconsWrappers": `searchIconsWrappers_lpQaq`,
	"filterIconsWrappers": `filterIconsWrappers_Xblm2`,
	"labelContainer": `labelContainer_ev2Xg`,
	"label": `label_tVNkc`,
	"infoWorkspace": `infoWorkspace_mW6vr`,
	"info": `info_yHzi8`,
	"infoUser": `infoUser_w7d6p`,
	"initials": `initials_AARIp`
};
export default ___CSS_LOADER_EXPORT___;
